// extracted by mini-css-extract-plugin
export default {"item":"Member_item__JK0R4"};